import React from 'react';
import '../MarsTheme.css';

const MarsNavbar = ({ categories, activeCategory, onSelectCategory }) => {
    return (
        <nav className="mars-navbar glass-panel">
            <ul className="nav-list">
                {categories.map(cat => (
                    <li
                        key={cat.id}
                        className={`nav-item ${activeCategory === cat.id ? 'active' : ''}`}
                        onClick={() => onSelectCategory(cat.id)}
                    >
                        {cat.title}
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default MarsNavbar;
